import type { DatabaseMetadata } from './types';

export type QuoteSnapshotIdentity = Pick<DatabaseMetadata, 'type' | 'source'>;

export function isQuoteSnapshot(
  database: QuoteSnapshotIdentity,
): boolean {
  return database?.type === 'quote'
    || database?.type === 'voice-quote'
    || database?.source?.createdBy === 'quote-builder';
}
